import React, { useEffect, useRef, useState } from "react";

const QuotationRowActions = ({
  item,
  menuRights,
  handleForecast,
  handlePrint,
  handleCopy,
  handleConvert,
  handleDelete,
  handleActivity,
  handleView,
  isLost = false,
  isRevisionDraft = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const actionRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeMenu = (event) => {
      if (actionRef.current?.contains(event.target)) return;
      setIsOpen(false);
    };

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", closeMenu);
    document.addEventListener("keydown", closeOnEscape);
    window.addEventListener("scroll", closeMenu, true);
    window.addEventListener("resize", closeMenu);

    return () => {
      document.removeEventListener("mousedown", closeMenu);
      document.removeEventListener("keydown", closeOnEscape);
      window.removeEventListener("scroll", closeMenu, true);
      window.removeEventListener("resize", closeMenu);
    };
  }, [isOpen]);

  const toggleMenu = () => {
    const rect = actionRef.current?.getBoundingClientRect();
    if (rect) {
      const estimatedMenuHeight = isLost ? 94 : menuRights?.canDelete ? 178 : 150;
      const opensBelow = rect.bottom + estimatedMenuHeight + 8 <= window.innerHeight;
      setMenuPosition({
        top: opensBelow ? rect.bottom + 4 : Math.max(8, rect.top - estimatedMenuHeight - 4),
        left: Math.max(8, rect.right - 148),
      });
    }
    setIsOpen((currentValue) => !currentValue);
  };

  const runAction = (handler) => {
    handler?.(item);
    setIsOpen(false);
  };

  return (
    <div className={`quote-row-actions${isOpen ? " is-open" : ""}`} ref={actionRef}>
      <button
        type="button"
        className="quote-row-actions-trigger"
        aria-label={`Actions for ${item?.quoteReference}`}
        aria-expanded={isOpen}
        title="Actions"
        onClick={toggleMenu}
      >
        <i className="fa fa-ellipsis-v" />
      </button>

      {isOpen && (
        <div
          className="quote-row-action-menu"
          style={{
            position: "fixed",
            top: `${menuPosition.top}px`,
            left: `${menuPosition.left}px`,
          }}
        >
          {isLost ? (
            <>
              {menuRights?.canView && (
                <button type="button" onClick={() => runAction(handleView)}>
                  <i className="fa fa-eye" />
                  View
                </button>
              )}
              <button type="button" onClick={() => runAction(handleCopy)}>
                <i className="fa fa-copy" />
                Copy
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={() => runAction(handleForecast)}
                disabled={isRevisionDraft}
              >
                <i className="fa fa-chart-bar" />
                Forecast
              </button>
              {menuRights?.canViewActivities === true && (
                <button type="button" onClick={() => runAction(handleActivity)}>
                  <i className="fa fa-history" />
                  Activity
                </button>
              )}
              <button
                type="button"
                onClick={() => runAction(handlePrint)}
                disabled={isRevisionDraft}
              >
                <i className="fa fa-print" />
                Print
              </button>
              <button type="button" onClick={() => runAction(handleCopy)}>
                <i className="fa fa-copy" />
                Copy
              </button>
              {item?.quoteType != "1" && (
                <button type="button" onClick={() => runAction(handleConvert)}>
                  <i className="fa fa-exchange-alt" />
                  Convert
                </button>
              )}
              {menuRights?.canDelete && (
                <button type="button" className="danger" onClick={() => runAction(handleDelete)}>
                  <i className="fa fa-trash" />
                  Delete
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(QuotationRowActions);
